module.exports = __webpack_public_path__ + "img/rodrigo.2935adc5.jpg";